export function isChannelCompatibleWithParent(
  channel: { parent_model_id?: string | null },
  parentModelId: string,
): boolean {
  return channel.parent_model_id === parentModelId;
}
